import { delay, eventChannel } from 'redux-saga';
import { call, cancel, fork, take } from 'redux-saga/effects';

/**
 * Listen to element events
 * @param source
 * @param eventName
 * @param init
 * @param throttle
 */
export const onEvent = (source, eventName, init = null, throttle = 10) =>
  eventChannel(emitter => {
    let _timeout;

    source.addEventListener(eventName, e => {
      if (throttle) {
        if (_timeout) clearTimeout(_timeout);
        _timeout = setTimeout(() => {
          emitter(e);
        }, throttle);
      } else {
        emitter(e);
      }
    });

    if (init) {
      init();
    }

    return () => {
      source.removeEventListener(eventName, emitter);
    };
  });

export const interval = (every, initialTrigger = true) => {
  return eventChannel(emitter => {
    let check = 0;
    const iv = setInterval(() => emitter(check++), every * 1000);

    // Trigger first emit after creation
    if (initialTrigger) {
      setTimeout(() => emitter(check++), 0);
    }

    return () => clearInterval(iv);
  });
};

export function* debounce(pattern, saga, ms, ...args) {
  function* delayedSaga(action) {
    yield call(delay, ms);
    yield call(saga, action, ...args);
  }

  let task;
  while (true) {
    const action = yield take(pattern);
    if (task) {
      yield cancel(task);
    }

    task = yield fork(delayedSaga, action);
  }
}



// WEBPACK FOOTER //
// ./app/helpers/saga.js